import { saveAs } from "file-saver";

export const DownloadTextFile = (content, filename, mimeType = "text/plain;charset=utf-8") => {
  const blob = new Blob(["\uFEFF", content], { type: mimeType });
  saveAs(blob, filename);
};

export const DownloadBlobFile = (blob, filename) => {
  saveAs(blob, filename);
};

export const CopyToClipboard = async (content) => {
  if (!navigator?.clipboard?.writeText) {
    throw new Error("Clipboard API is not available");
  }

  await navigator.clipboard.writeText(content);
};
